/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const StepForwardIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Step Forward',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m10.25098,15.95508c-.38281,0-.76562-.10059-1.11572-.2998-.71094-.40625-1.13525-1.13574-1.13525-1.9541v-7.40234c0-.81836.42432-1.54785,1.13525-1.9541.71143-.40332,1.55615-.39746,2.26025.01758l6.25439,3.70117c.69189.40918,1.10449,1.13281,1.10449,1.93652s-.4126,1.52734-1.10449,1.93652l-6.25439,3.70117c-.35742.21094-.75098.31738-1.14453.31738Zm.00391-10.40918c-.17139,0-.30811.0625-.37646.10156-.11377.06543-.37842.25879-.37842.65137v7.40234c0,.39258.26465.58594.37842.65137.11377.06445.41406.19141.75342-.00586l6.25439-3.70117c.33252-.19629.36816-.5166.36816-.64551s-.03564-.44922-.36816-.64551l-6.25439-3.70117c-.13477-.08008-.26367-.10742-.37695-.10742Z"
      fill="currentColor"
    />
    <path
      d="m3.75,16h-.5c-1.24072,0-2.25-1.00977-2.25-2.25v-7.5c0-1.24023,1.00928-2.25,2.25-2.25h.5c1.24072,0,2.25,1.00977,2.25,2.25v7.5c0,1.24023-1.00928,2.25-2.25,2.25Zm-.5-10.5c-.41357,0-.75.33691-.75.75v7.5c0,.41309.33643.75.75.75h.5c.41357,0,.75-.33691.75-.75v-7.5c0-.41309-.33643-.75-.75-.75h-.5Z"
      fill="currentColor"
    />
  </svg>`;
};
